import {customElement} from "lit/decorators.js";
import {DialogAnchorTemplateContent} from "./dialogAnchorTemplateContent";


@customElement("eop-download-dialog")
export class EopDownloadDialog extends DialogAnchorTemplateContent {

    public connectedCallback(): void {
        super.connectedCallback();

        if (!this.dialogContent) {
            return;
        }

        this.dialogContent.classList.add("download-dialog");

        if (this.dialogContent.classList.contains("lightbox-image")) {
            this.addEventListener("click", event => {
                const isClickOnImage = event.target === this.querySelector("img") || (event.target as HTMLElement).classList.contains("lightbox-image-preview-icon");
                if (isClickOnImage) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.openDialog(event);
                }
            });
        } else if (this.dialogContent.classList.contains("disclaimer-dialog")) {
            this.addEventListener("click", event => {
                const isClickOnImageOrLabel = event.target === this.querySelector("img") || (event.target as HTMLElement).classList.contains("download-label");
                if (isClickOnImageOrLabel) {
                    event.preventDefault();
                    event.stopPropagation();
                    this.openDialog(event);
                }
            });
        }

        this.addEventListener("keydown", event => {
            if (event.key !== "Enter" && event.key !== " ") {
                return;
            }
            if (event.target instanceof HTMLElement && event.target.classList.contains("download-preview-image")) {
                event.target.querySelector<HTMLImageElement>("img")!.click();
            } else if (event.target instanceof HTMLElement) {
                event.target.click();
            }
        });
    }
}
